import React from "react";
import "./experience.css";
import ExperienceCard from "./experienceCard";
import { experience } from "../../data";

export default function ExperienceComponent() {
  return (
    <section className="section" id="experience">
      <div className="section-inner">
        <h2 className="section-title">Experience</h2>
        <span className="section-title-accent" />
        <p className="section-subtitle">
          Roles where I&apos;ve shipped AI and full-stack systems to production.
        </p>

        <div className="timeline">
          {experience["experience"].map((data, id) => (
            <ExperienceCard
              key={id}
              time={data.time}
              desc={data.desc}
              componyName={data.componyName}
              link={data.link}
              designation={data.Designation}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
